export default __webpack_public_path__ + "static/media/login-right.ecbaa584.png";